import { FC } from 'react'

import styled from 'styled-components'

import { SmartImage } from 'src/Components/SmartImage'
import { variables } from 'src/Styled/variables'
import defaultAva from 'src/Assets/Png/ava.png'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'

const SearchResult = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
`
const SearchPhoto = styled(SmartImage)`
  border-radius: 60px;
  overflow: hidden;
`
const SearchText = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};

  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  line-height: 150%;
  display: flex;
  flex-direction: column;
`
const SearchTextTitle = styled.div`
  font-weight: ${variables.fontWeight600};
`

export const UserDataInfo: FC = () => {
  const { search } = useCustomSearchParams()
  const avatar = search.get('avatarUrl') || ''
  const nickname = search.get('nickname') || ''
  const displayName = search.get('displayName') || ''
  const followers = search.get('followers') || '0'
  const hasUserData =
    Boolean(nickname) && Boolean(displayName) && Boolean(followers)

  if (!hasUserData) {
    return null
  }

  return (
    <SearchResult>
      <SearchPhoto
        src={avatar}
        fallbackSrc={defaultAva}
        alt='photo'
        width={40}
        height={40}
      />
      <SearchText>
        <SearchTextTitle>{nickname}</SearchTextTitle>
        <div>
          {followers}
          &nbsp;
          {Number(followers) !== 1 ? 'Followers' : 'Follower'}
        </div>
      </SearchText>
    </SearchResult>
  )
}
